import CountUp from 'react-countup';
import ReactApexChart from 'react-apexcharts';
import React, { useEffect, useState } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { APIClient } from '../../../../helpers/api_helper';

export const DashboardSalesEvolutionChart = ({ isShow, office }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState(null);

  const api = new APIClient();

  function formatDataToChart(data) {
    let days = [];
    let prevision = [];
    let acumulated = [];
    let lastMonth = [];
    let lastYear = [];
    let ofDay = [];

    // testar verificação quando obter data
    // a ideia é que apenas set os states com os dias corridos até o atual
    // let currentDay = new Date().getDate();

    for (let i = 0; i < data.length; i++) {
      days.push([data[i].day, data[i].dayName]);

      // if (data[i].day <= currentDay) {
      prevision.push(data[i].prevision);
      acumulated.push(data[i].salesAcumulated);
      lastMonth.push(data[i].salesLastMonth);
      lastYear.push(data[i].salesLastYear);
      ofDay.push(data[i].salesOfDay);
      // }
    }

    setChartData({
      days,
      prevision,
      acumulated,
      lastMonth,
      lastYear,
      ofDay,
    });
  }

  const options = {
    chart: {
      height: 345,
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    series: [
      {
        name: 'Vendido no dia',
        data: chartData?.ofDay,
        visible: false,
      },
      {
        name: 'Vendas no mês',
        data: chartData?.acumulated,
      },
      {
        name: 'Vendas mês anterior',
        data: chartData?.lastMonth,
      },
      {
        name: 'Vendas ano anterior',
        data: chartData?.lastYear,
      },
      {
        name: 'Previsão',
        data: chartData?.prevision,
      },
    ],
    colors: ['#fff', '#228B22', '#8397da', '#A9A9A9', '#B8860B'],
    tooltip: {
      x: {
        formatter: function (val) {
          return `Dia ${val}`;
        },
      },
      y: {
        formatter: function (val) {
          if (typeof val !== 'undefined' && val !== null) {
            return val.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
            });
          }
          return 'R$ 0,00';
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [2, 3, 2, 2],
      curve: 'straight',
      dashArray: [8, 0, 8, 8],
    },
    markers: {
      style: 'inverted',
      size: [0, 4, 0, 0, 0],

      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      // axisTicks: {
      //   show: true,
      //   borderType: 'dotted',
      //   color: '#000',
      //   height: 6,
      // },
      categories: chartData?.days,
      labels: {
        rotate: 0,
        formatter: function (value) {
          return value;
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value.toLocaleString('pt-br', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
          });
        },
      },
    },
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 2,
    },
    legend: {
      formatter: function (seriesName, opts) {
        if (seriesName === 'Vendido no dia') {
          return null;
        }
        return [seriesName];
      },
    },
  };

  const getSalesForecast = async (office) => {
    await api.get(`/overview/sales-forecast?office=${office}`).then((res) => {
      setData(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    getSalesForecast(office);
  }, [office]);

  useEffect(() => {
    if (data.data) {
      formatDataToChart(data.data);
    }
  }, [data.data]);

  const DashboardSalesEvolutionChartView = () => {
    return (
      <React.Fragment>
        <Card className="card card-height-100">
          <CardHeader className="card-header border-0 align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Evolução de Vendas</h4>
          </CardHeader>

          <CardHeader className="card-header p-0 border-0 bg-soft-light">
            <div className="row g-0 text-center">
              <Col className="col-6 col-sm-3">
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        end={data?.resume?.salesThisMonth}
                        duration={1}
                        decimals={2}
                        decimal=","
                        separator="."
                      />
                    </span>
                  </h5>
                  <p className="text-muted mb-0">Este mês</p>
                </div>
              </Col>
              <Col className="col-6 col-sm-3">
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        end={data?.resume?.prevision}
                        duration={1}
                        decimals={2}
                        decimal=","
                        separator="."
                      />
                    </span>
                  </h5>
                  <p className="text-muted mb-0">Previsão</p>
                </div>
              </Col>
              <Col className="col-6 col-sm-3">
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        end={data?.resume?.salesLastMonth}
                        duration={1}
                        decimals={2}
                        decimal=","
                        separator="."
                      />
                    </span>
                  </h5>
                  <p className="text-muted mb-0">Mês Passado</p>
                </div>
              </Col>
              <Col className="col-6 col-sm-3">
                <div className="p-3 border border-dashed border-start-0 border-end-0">
                  <h5 className="mb-1">
                    <span className="counter-value">
                      R${' '}
                      <CountUp
                        start={0}
                        end={data?.resume?.salesLastYear}
                        duration={1}
                        decimals={2}
                        decimal=","
                        separator="."
                      />
                    </span>
                  </h5>
                  <p className="text-muted mb-0">Ano Passado</p>
                </div>
              </Col>
            </div>
          </CardHeader>

          <CardBody className="card-body p-0 pb-2">
            <div className="w-100">
              <ReactApexChart
                dir="ltr"
                type="line"
                height="345"
                series={options.series}
                options={options}
                className="apex-charts"
              />
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  };

  return loading ? (
    <Col xs={12} md={6} lg={6}>
      <Card className="card card-height-100">
        <SkeletonTheme baseColor="#8B919F">
          <Row className="p-1">
            <div className="text-center">
              <Skeleton height={515} />
            </div>
          </Row>
        </SkeletonTheme>
      </Card>
    </Col>
  ) : isShow ? (
    <Col xs={12} md={6} lg={6}>
      <DashboardSalesEvolutionChartView />
    </Col>
  ) : null;
};
